(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kez-around-the-usa"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kez-reels')) {
    class KezReels extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.kez-usa__track');
        this.prevBtn = this.querySelector('[data-kez-prev]');
        this.nextBtn = this.querySelector('[data-kez-next]');
        this.cards = Array.from(this.querySelectorAll('.kez-usa__card'));
        if (!this.track) return;

        this.onScroll = () => this.updateNav();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

        this.cards.forEach((card) => {
          const video = card.querySelector('video');
          const btn = card.querySelector('.kez-usa__play');
          if (!video || !btn) return;
          btn.addEventListener('click', () => this.play(card, video));
          video.addEventListener('ended', () => KezReels.reset(card, video));
        });

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.updateNav());
          this.ro.observe(this.track);
        }

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) return;
              const v = entry.target.querySelector('video');
              if (v && !v.paused) v.pause();
            });
          }, { threshold: 0.35 });
          this.cards.forEach((card) => this.io.observe(card));
        }

        this.onBlockSelect = (e) => {
          const card = e.target && e.target.closest ? e.target.closest('.kez-usa__card') : null;
          if (card && this.contains(card)) card.scrollIntoView({ block: 'nearest', inline: 'start' });
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.updateNav();
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      play(card, video) {
        document.querySelectorAll('.kez-usa__card.is-playing').forEach((other) => {
          if (other === card) return;
          const v = other.querySelector('video');
          if (v) KezReels.reset(other, v);
        });
        card.classList.add('is-playing');
        video.controls = true;
        const p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(() => KezReels.reset(card, video));
        }
      }

      static reset(card, video) {
        video.pause();
        video.controls = false;
        video.load(); // back to the poster image
        card.classList.remove('is-playing');
      }

      step(dir) {
        const first = this.cards[0];
        if (!first) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: dir * (first.offsetWidth + gap) });
      }

      updateNav() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.toggleAttribute('data-overflow', max > 2);
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= max - 2;
      }
    }
    customElements.define('kez-reels', KezReels);
  }

  } catch(e) { console.error(e); }
})();
})();
